import { FETCH_ACTIONS } from '../constants/action.constants';

const initialState = {};

const fetch = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_ACTIONS.START:
      return { ...state, [action.key]: { ...(state[action.key] || {}), fetching: true } };
    case FETCH_ACTIONS.DONE:
      return { ...state, [action.key]: { ...(state[action.key] || {}), fetching: false, fetched: true } };
    case FETCH_ACTIONS.ERROR:
      return {
        ...state,
        [action.key]: { ...(state[action.key] || {}), fetching: false, error: action.payload, fetched: true }
      };
    case FETCH_ACTIONS.RESET:
      return { ...state, [action.key]: { ...(state[action.key] || {}), fetching: false, fetched: false, error: null } };
    default:
      return state;
  }
};

export default fetch;
